import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TextBlockIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1 2.25C1 1.55964 1.55964 1 2.25 1H13.75C14.4404 1 15 1.55964 15 2.25V5.5H13.5V2.5H2.5V5.5H1V2.25Z"
		></path>
		<path
			fill="currentColor"
			d="M13.5 10V13.5H2.5V10H1V13.75C1 14.4404 1.55964 15 2.25 15H13.75C14.4404 15 15 14.4404 15 13.75V10H13.5Z"
		></path>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.94437 12C6.12497 12 6.28317 11.879 6.33043 11.7047L6.78607 10.0242H9.21692L9.67377 11.7049C9.72112 11.8791 9.87926 12 10.0598 12H10.4704C10.7359 12 10.9278 11.746 10.8551 11.4906L8.80767 4.29059C8.75877 4.11863 8.6017 4 8.42293 4H7.58126C7.40256 4 7.24553 4.11853 7.19657 4.2904L5.14519 11.4904C5.07241 11.7459 5.26426 12 5.52988 12H5.94437ZM8.90169 8.86443L8.02605 5.64295H7.97395L7.10051 8.86443H8.90169Z"
		></path>
		<path fill="currentColor" d="M15 7H13V8.5H15V7Z"></path>
		<path fill="currentColor" d="M3 7H1V8.5H3V7Z"></path>
	</svg>
))
